module.exports = __webpack_public_path__ + "img/ic_wifi_connect.98d4096b.png";